import {
  FETCH_VERSION_SUCCESS,
  FETCH_SEARCH_TOKEN_SUCCESS,
} from './actionTypes'

const defaultConfig = {
  appName: null,
  apiEndpoint: null,
  appVersion: null,
  latestVersion: null,
  collabEndpoint: null,
  searchToken: null,
  searchApplicationId: null,
}

export default function configReducer(state = defaultConfig, action) {
  switch (action.type) {
    case FETCH_VERSION_SUCCESS: {
      const latestVersion = action.payload
      // Prevent config state mutation if version didnt change
      return latestVersion === state.latestVersion
        ? state
        : { ...state, latestVersion }
    }
    case FETCH_SEARCH_TOKEN_SUCCESS: {
      const { searchToken, searchApplicationId } = action.payload
      return { ...state, searchToken, searchApplicationId }
    }
    default: {
      return state
    }
  }
}
